import React, { useEffect, useState } from 'react';
import './Payment.css';
import { useNavigate } from 'react-router-dom';
import { getSessionStorage } from '../../utils/helper';
import Button from '../../components/button/Button';

const Payment: React.FC = () => {
  const navigate = useNavigate();
  const [selectedMethod, setSelectedMethod] = useState<string>('qr-promptpay');

  useEffect(() => {
    const raw = getSessionStorage('i')
    if (!raw) {
      navigate('/')
    }
  }, [])

  const paymentMethods = [
    {
      id: 'qr-promptpay',
      icon: '/assets/icons/icon-qr-promptpay.svg',
      name: 'QR พร้อมเพย์ / โอนเงิน',
      desc: 'สแกน QR หรือโอนผ่านแอปธนาคาร',
    },
  ];

  return (
    <section className="payment-wrapper">
      <div className="payment-container lg:container lg:mx-auto">

        {/* Header */}
        <div className="payment-header">
          <h2 className="payment-title">ชำระเงิน</h2>
          <p className="payment-subtitle">เลือกช่องทางการชำระเงิน</p>
        </div>

        {/* Payment methods */}
        <div className="payment-section">
          <p className="payment-section-label">วิธีการชำระเงิน</p>

          <div className="payment-method-list">
            {paymentMethods.map((method) => (
              <button
                key={method.id}
                type="button"
                className={`payment-method-card ${selectedMethod === method.id ? 'selected' : ''}`}
                onClick={() => setSelectedMethod(method.id)}
              >
                <div className="method-icon-wrap">
                  <img src={method.icon} alt={method.name} className="method-icon" />
                </div>
                <div className="method-info">
                  <p className="method-name">{method.name}</p>
                  <p className="method-desc">{method.desc}</p>
                </div>
                <div className={`method-radio ${selectedMethod === method.id ? 'checked' : ''}`}>
                  {selectedMethod === method.id && (
                    <span className="radio-dot" />
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>

        {/* Security badge */}
        <div className="payment-security">
          <img src="/assets/icons/icon-check.svg" alt="secure" className="security-icon" />
          <span>การชำระเงินปลอดภัย ข้อมูลของคุณถูกเข้ารหัส</span>
        </div>

        {/* CTA */}
        <div className="payment-cta">
          <Button
            variant="primary"
            fullWidth
            className="max-w-[28rem]"
            disabled={!selectedMethod}
            onClick={() => {
              navigate(`/payment-detail/${getSessionStorage('i')}`)
            }}
          >
            ดำเนินการชำระเงิน
          </Button>
        </div>

      </div>
    </section>
  )
}

export default Payment;
